import axios from "axios";
import config from "../config";

const chatRequest = {
  withCredentials: true,
};

export async function bootstrapChatSession() {
  const response = await axios.get(`${config.baseURL}/chat/bootstrap`, chatRequest);
  return response.data;
}

export async function fetchChatMembers() {
  const response = await axios.get(`${config.baseURL}/chat/members`, chatRequest);
  return response.data?.members || [];
}

export async function createDirectChat(userId) {
  const response = await axios.post(
    `${config.baseURL}/chat/direct`,
    { userId },
    chatRequest,
  );
  return response.data?.channel;
}

